// Височината на редовете в „Разнасяне на отчети" — ОБЩИЯТ стандарт от
// `components/list/density.ts` (34px с мишка, ≥44px с пръст), същият като в
// справките, работните листове и „Целия списък". Тук са само псевдоними, за
// да се чете кой ред какъв е; собствени числа НЕ се пишат.
//
// Контролите в реда (antd size="small" — селект за склад, поле за количество)
// са 24px с мишка: 1 (граница) + 4 + 24 + 4 = 33 ≤ 34. С пръст (pointer:
// coarse — и таблет в landscape) контролите са 36px (scoped CSS в
// `ReportPostingWriteoffCard`); отстъпът от 3px с пръст е в самия `ROW_INNER`:
// 1 + 3 + 36 + 3 = 43 → 44.
import { ROW_DENSE, ROW_READ } from "../../components/list/density";

// Ред с данни и контроли („Изписване от склад", подредовете по склад и на
// заместител)
export const POSTING_ROW = ROW_DENSE;

// Ред само за четене („Продадено", рецептите в разбивката при отчета)
export const POSTING_READ_ROW = ROW_READ;

// Ред, който се натиска (сервитьор / станция в разбивката при отчета)
export const POSTING_TAP_ROW = ROW_READ;
